<template>
	<div class="conpyright_content">
        <p>版权© 2020 同和金属材料（上海）有限公司 版权所有</p>
        <span>
            <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" target="_blank">苏ICP备18045935号-1</a>
        </span>
        <span id="beian">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51011202000352" target="_blank">
                <img src="https://resources.xycoder.com/dowa/beian.png"> 
                <p>苏公网安备 51011202000352号</p>
            </a>
        </span>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue';
	import store from '@/store/index.js';

	export default {
		name:"copyrightBottom",
		data(){
			return {
			}
		},
		mounted(){
		},
		methods:{
			
		}

}
</script>


<style scoped>
	.conpyright_content {
        background-color: rgb(250, 248, 248);
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
    }

    .conpyright_content::after{
        border-top: 1px solid white;
        transform: scale(0.5);
        transform-origin: 0 0;
    }

    p{
        color: black;
        text-align: center;
        display: inline-block;
        display: inline-block;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
    }
    span{
        display: block;
        text-align: center;
    }
    span a{
        color: black;
        text-decoration: none;
    }
    span a:hover{
        color: black;
    }
    span a img{
        display: inline-block;
    }
    span a p{
        display: inline;
    }
    #beian{
        padding-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/CopyrightBottom.vue